/**
 * Map of icon type to public path. Use with <img src={iconPaths[type] ?? iconPaths.default} />.
 */
export const iconPaths = {
  circle: "/icons/circle.svg",
  search: "/icons/search-icon.svg",
  companyLogo: "/icons/Logo-01 1.svg",
  companyLogoMobile: "/icons/Carrum_mv.svg",
  menu: "/icons/basil_menu-outline.svg",
  avatar: "/icons/avatar.svg",
  leftNavigation: "/icons/left_navigation.svg",
  rightNavigation: "/icons/rightarrow.svg",
  close_cross_icon: "/icons/close-cross-icon.svg",
  verticalThreeDots: "/icons/three-dots-vertical.svg",
  download: "/icons/download-svgrepo-com.svg",
  filterIcon: "/icons/filter-svgrepo-com.svg",
  darkFilterIcon: "/icons/dark-filter-svgrepo-com.svg",
  sortDown: "/icons/sort-down-svgrepo-com.svg",
  sortUp: "/icons/sort-up-svgrepo-com.svg",
  sortIcon: "/icons/sort-svgrepo-com.svg",
  upArrow: "/icons/up-arrow-svgrepo-com.svg",
  downArrow: "/icons/bottom-arrow-svgrepo-com.svg",
  default: "/icons/default.svg",
};
